import styled, { css } from 'styled-components';
import { ReactComponent as _DashedLink } from 'styles/icons/dashed-link-icon.svg';
import { ReactComponent as _LinkIcon } from 'styles/icons/link-text.svg';
import { ReactComponent as _HighlightIcon } from 'styles/icons/highlight.svg';
import { ReactComponent as _UnderlineIcon } from 'styles/icons/underline.svg';
import { ReactComponent as _StrikethroughIcon } from 'styles/icons/strikethrough.svg';
import { ReactComponent as _DeleteIcon } from 'styles/icons/delete-icon.svg';
import { ReactComponent as _NameIcon } from 'styles/icons/text.svg';

import { color } from 'styles/settings';
import { linkButtonIds } from 'components/pspdf/components/markup-menu';
import { withModifiers } from 'utils/styles';

const iconCss = css`
  position: relative;
  top: 7px;
  height: 28px;
  pointer-events: none;
`;

export const Separator = styled.div`
  width: 1px;
  height: 58px;
  background-color: ${color.ui.backgroundGray};
`;

export const MarkupMenuIcon = styled.div.attrs({
  className: ({ className }) =>
    [className, 'Cortlex-Markup-Icon toggleable'].filter(Boolean).join(' '),
})`
  width: 50px;
  height: 58px;
  padding: 0;
  box-sizing: border-box;
  cursor: pointer;
  color: ${color.neutral.plainBlack};
  transition: color 0.2s;

  :hover {
    color: ${({ id }) =>
      id === linkButtonIds.delete ? color.ui.danger : color.brand.gold};
  }

  &.selected {
    color: ${color.brand.gold};
  }

  ${withModifiers('selected')`
    color: ${color.brand.gold};
  `}
`;

export const NameIcon = styled(_NameIcon)`
  ${iconCss};
`;

export const LinkIcon = styled(_LinkIcon)`
  ${iconCss};
`;

export const HighlightIcon = styled(_HighlightIcon)`
  ${iconCss};
`;

export const UnderlineIcon = styled(_UnderlineIcon)`
  ${iconCss};
`;

export const StrikethroughIcon = styled(_StrikethroughIcon)`
  ${iconCss};
`;

export const DashedLink = styled(_DashedLink)`
  ${iconCss};
  color: ${color.brand.blue};
`;

export const DeleteLink = styled(_DeleteIcon)`
  ${iconCss};
`;
